/**
 * @generated SignedSource<<f0e4bfb7ee486b72586c29b63a512db7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesWidgetTabContentHomeV2Article$data = {
  readonly entityId: string;
  readonly series: ReadonlyArray<{
    readonly entityId?: string;
    readonly publishedDate?: number | null | undefined;
    readonly urlAlias?: string;
    readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink" | "homeSecondaryV2ContentItemContent">;
  } | null | undefined> | null | undefined;
  readonly seriesShortLabel: string | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "seriesWidgetTabContentHomeV2Article";
};
export type seriesWidgetTabContentHomeV2Article$key = {
  readonly " $data"?: seriesWidgetTabContentHomeV2Article$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetTabContentHomeV2Article">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "entityLink"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "seriesWidgetTabContentHomeV2Article",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seriesShortLabel",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "series",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publishedDate",
              "storageKey": null
            },
            (v2/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeSecondaryV2ContentItemContent"
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "withLandscape250x99",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "withSize540x360",
                  "value": true
                }
              ],
              "kind": "FragmentSpread",
              "name": "contentCoverImageContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "817e4c9ed3323e7ce6c467b55b4a3e78";

export default node;
